import React, { useEffect, useState } from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import { loadStoreSettings } from "../../util/storeSettings";
import { POLICIES, policyText } from "../../util/policyDefaults";

/** /policies/:type: the store's privacy, refund, shipping, or terms page. */
export default function PolicyPage() {
  const { type } = useParams();
  const policy = POLICIES.find((p) => p.type === type);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let active = true;
    loadStoreSettings().then((s) => active && setSettings(s || {})).catch(() => active && setSettings({}));
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (policy) {
      document.title = `${policy.title}${settings?.storeName ? ` — ${settings.storeName}` : ""}`;
      window.scrollTo(0, 0);
    }
  }, [policy, settings]);

  if (!policy) return <Redirect to="/404" />;

  const blocks = settings ? policyText(type, settings).split(/\n\s*\n/) : [];

  return (
    <div className="py-5" style={{ backgroundColor: "#f8fafc", minHeight: "70vh" }}>
      <div className="container" style={{ maxWidth: 780 }}>
        <nav className="small mb-3 text-muted">
          <Link to="/" className="text-muted">Home</Link> / {policy.title}
        </nav>
        <article className="bg-white p-4 p-md-5 rounded-4 border policy-page">
          <h1 className="fw-bold mb-4" style={{ fontSize: "clamp(24px, 3vw, 32px)" }}>{policy.title}</h1>
          {!settings ? (
            <div className="text-center py-4"><div className="spinner-border text-secondary" role="status" /></div>
          ) : (
            blocks.map((block, index) => {
              const lines = block.split("\n");
              return (
                <div key={index} className="mb-3">
                  {lines.map((line, i) => {
                    if (line.startsWith("# ")) return <h2 key={i} className="fw-bold mt-4 mb-2" style={{ fontSize: 18 }}>{line.slice(2)}</h2>;
                    if (line.startsWith("- ")) return <li key={i} className="ms-3" style={{ lineHeight: 1.7 }}>{line.slice(2)}</li>;
                    return <p key={i} className="mb-1" style={{ lineHeight: 1.7, color: "#334155" }}>{line}</p>;
                  })}
                </div>
              );
            })
          )}
        </article>
        <div className="d-flex flex-wrap gap-3 mt-3 small">
          {POLICIES.filter((p) => p.type !== type).map((p) => (
            <Link key={p.type} to={`/policies/${p.type}`} className="text-muted">{p.title}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}
